import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { motion, useViewportScroll } from "framer-motion";
import "./Styles/SkillSec.css";

function SkillSec() {
  // -- UX Animation --
  const vHeight = window.innerHeight;
  const { scrollY } = useViewportScroll();
  const [scrollValue, setScrollValue] = useState(0);

  const frontList = {
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.1,
        staggerChildren: 0.1,
      },
    },
    hidden: {
      x: -900,
      opacity: 0,
      transition: {
        when: "afterChildren",
      },
    },
  };

  const frontItem = {
    visible: {
      x: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 60, damping: 11 },
    },
    hidden: { x: -900, opacity: 0 },
    hover: {
      backgroundImage: `radial-gradient(
      circle farthest-corner at 10% 20%,
      rgba(223, 244, 148, 1) 0%,
      rgba(128, 248, 174, 1) 90%
    )`,
    },
  };

  const backList = {
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.1,
        staggerChildren: 0.1,
      },
    },
    hidden: {
      x: 900,
      opacity: 0,
      transition: {
        when: "afterChildren",
      },
    },
  };

  const backItem = {
    visible: {
      x: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 60, damping: 11 },
    },
    hidden: { x: 900, opacity: 0 },
    hover: {
      backgroundImage: "linear-gradient(to right, #3c1053, #ad5389)",
    },
  };

  useEffect(() => {
    scrollY.onChange((e) => {
      setScrollValue(scrollY.get());
    });
  }, [scrollY]);

  return (
    <Container fluid className="skillSec">
      <Row>
        <Col className="text-center skillSec__title">
          <motion.h1
            animate={{
              opacity: scrollValue > vHeight * 1.35 ? 1 : 0,
              y: scrollValue > vHeight * 1.35 ? 0 : +50,
              transition: { type: "tween", duration: 0.5 },
            }}
          >
            My Skill Is My <span className="skillSec__bold">Strength</span>
          </motion.h1>
        </Col>
      </Row>
      <Row>
        <Col xs={6} className="skillSec__front">
          <motion.h3
            animate={{
              opacity: scrollValue > vHeight * 1.5 ? 1 : 0,
              y: scrollValue > vHeight * 1.5 ? 0 : +50,
              transition: { type: "tween" },
            }}
          >
            Front-End
          </motion.h3>
          <motion.ul
            variants={frontList}
            animate={scrollValue > vHeight * 1.5 ? "visible" : "hidden"}
          >
            <motion.li variants={frontItem} whileTap="hover" whileHover="hover">
              Javascrip
            </motion.li>
            <motion.li variants={frontItem} whileTap="hover" whileHover="hover">
              React Js
            </motion.li>
            <motion.li variants={frontItem} whileTap="hover" whileHover="hover">
              Web Technologies
            </motion.li>
            <motion.li variants={frontItem} whileTap="hover" whileHover="hover">
              CSS Frameworks
            </motion.li>
            <motion.li variants={frontItem} whileTap="hover" whileHover="hover">
              Interactive Effects
            </motion.li>
            <motion.li variants={frontItem} whileTap="hover" whileHover="hover">
              Framer-Motion
            </motion.li>
          </motion.ul>
        </Col>
        <Col xs={6} className="skillSec__back">
          <motion.h3
            animate={{
              opacity: scrollValue > vHeight * 1.5 ? 1 : 0,
              y: scrollValue > vHeight * 1.5 ? 0 : +50,
              transition: { type: "spring", stiffness: 150 },
            }}
          >
            Back-End
          </motion.h3>
          <motion.ul
            variants={backList}
            animate={scrollValue > vHeight * 1.5 ? "visible" : "hidden"}
          >
            <motion.li variants={backItem} whileTap="hover" whileHover="hover">
              Node Js
            </motion.li>
            <motion.li variants={backItem} whileTap="hover" whileHover="hover">
              Express Js
            </motion.li>
            <motion.li variants={backItem} whileTap="hover" whileHover="hover">
              JQuery
            </motion.li>
            <motion.li variants={backItem} whileTap="hover" whileHover="hover">
              MySQL
            </motion.li>
            <motion.li variants={backItem} whileTap="hover" whileHover="hover">
              RESTful API
            </motion.li>
            <motion.li variants={backItem} whileTap="hover" whileHover="hover">
              Firebase
            </motion.li>
          </motion.ul>
        </Col>
      </Row>
      {/* <h6 className=" skillSec__end">More are under construction...</h6> */}
    </Container>
  );
}

export default SkillSec;
